export const AirportExcelHeader = [
  {
    header: "AIRPORT CODE",
    key: "AIRPORT CODE",
    width: 25,
  },
  {
    header: "AIRPORT NAME",
    key: "AIRPORT NAME",
  },
  {
    header: "THREE DIGIT AIRPORT CODE",
    key: "THREE DIGIT AIRPORT CODE",
  },
  {
    header: "CREATED BY",
    key: "CREATED BY",
  },
  {
    header: "CREATED DATE",
    key: "CREATED DATE",
  },
];

export const AirportExcelName = "Airport List";
